<script lang="ts">
import { Themes } from '@/utils/helper-objects'
import { defineComponent } from 'vue'

/**
 * Trustpilot banner.
 */
export default defineComponent({
  setup() {
    return {
      Themes,
    }
  },
})
</script>

<template>
  <AppBanner labelled-by="trustpilot" class="relative">
    <div
      class="@md/main:rounded-md bg-black mask-squiggle"
      :style="{
        '--mask-squiggle-url': `url('/assets/images/masks/trustpilot-background.svg')`,
      }"
    >
      <div id="trustpilot" class="sr-only">
        {{ BUSINESS_NAME }} Trustpilot widget with user reviews
      </div>

      <AppTrustpilot
        class="trustpilot-banner flex w-full justify-center rounded-md py-6 @lg/main:px-0 !bg-transparent"
      />
    </div>
  </AppBanner>
</template>

<style lang="scss" scoped>
.trustpilot-banner {
  :deep(iframe) {
    @apply h-[20px] !important;
  }
}
</style>
